import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { DashboardItem } from './DashboardItem.js';
import { TranslationContext } from "./hooks/useTranslationContext";

function resultList(inputDevices, resultList) {
    for (let device of inputDevices) {
        const { uuid, state } = device;

        if (!state || uuid === 'system') {
            continue;
        }
        resultList.push(
            <DashboardItem key={uuid} {...device} uuid={uuid} level={0} />
        );
    }
}

export const DashboardList = ({ alarmDevices, warnedDevices, otherDevices, canCreateConnections }) => {
    const t = useContext(TranslationContext);
    const deviceList = useMemo(() => {
        const list = [];
        resultList(alarmDevices, list);
        resultList(warnedDevices, list);
        resultList(otherDevices, list);
        return list;
    }, [ alarmDevices, warnedDevices, otherDevices ]);


    return (
        <div>
            { deviceList.length === 0 ? (
                <div className="empty">
                    <div className="empty-icon">
                        <i className="icon icon-people"></i>
                    </div>
                    <p className="empty-title h5">{ t("main.no_devices_found") }</p>
                    { canCreateConnections ? (
                        <React.Fragment>
                            <p className="empty-subtitle">{ t('main.add_connections_for_devices') }</p>
                            <div className="empty-action">
                                <Link className="btn btn-primary" to="/settings/devices">{ t('main.button_connection_management') }</Link>
                            </div>
                        </React.Fragment>
                    ) : (
                        <p className="empty-subtitle">{ t('main.contact_admin_for_devices') }</p>
                    )}
                </div>
            ) : (
                <React.Fragment>
                    { deviceList }
                </React.Fragment>
            )}
        </div>
    );
}